module.exports = __webpack_public_path__ + "static/img/3389_phase_function_Paper_Points.b80de31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3389_phase_function_Paper_Points.png
// module id = RgQa
// module chunks = 0